import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import Button from '~/components/common/Button';
import {verifyEmailAction} from '~/modules/verify/actions';
import mapDispatch from '~/misc/mapDispatch';
import {modalClose} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

import css from './index.css';

class EmailValidate extends React.Component {
  constructor(props) {
    super(props);
    this.sendVerifyEmail = this.sendVerifyEmail.bind(this);
  }

  render() {
    if (isEmpty(this.props.context)) {
      return null;
    }

    return (
      <div className={css.popwrap}>
        <h1 className={css.header}>{this.renderHeader(this.props.context)}</h1>
        <p
          className={css.txtContent}
          dangerouslySetInnerHTML={{__html: this.renderContent(this.props.context)}}
        />
        <div className={css.btnWrap}>
          <Button onClick={this.sendVerifyEmail} className={css.wide} mods={['action', 'strench']}>
            {this.renderBtn(this.props.context)}
          </Button>
        </div>

      </div>
    );
  }

  renderHeader(data) {
    if (data.type === 'askPop') {
      return 'Verify your email';
    }
    if (data.type === 'tipsPop') {
      return 'Welcome to Truckloads';
    }
    return 'Please validate your account';
  }

  renderContent(data) {
    if (data.type === 'askPop') {
      return `Your email is not verified.
      <br/>Please click the button below to send
      <br/>a verification email to
      <br/><span style='word-break: break-all'>${data.email}.</span>`;
    }
    if (data.type === 'tipsPop') {
      return `Your email is not verified.
      <br/>Please click the button below to send
      <br/>a verification email to
      <br/><span style='word-break: break-all'>${data.email}.</span>`;
    }
    return `To provide a better service, we need to validate all carriers’ accounts.
      Your account has not been activated or your profile is incomplete.
      Some features and the contact information for brokers are locked until the missing
      information has been provided.
      <br/>Please download our Truckloads app to activate your account or fill out your profile.`;
  }

  renderBtn(data) {
    if (data.type === 'tipsPop') {
      return 'OK';
    }
    return 'Send Verification Email';
  }

  sendVerifyEmail(e) {
    if (e.target.innerHTML === 'OK') {
      this.props.closePop();
      return null;
    }
    return this.props.verifyEmail();
  }
}

export default connect(null, mapDispatch({
  verifyEmail: () => verifyEmailAction(),
  closePop: () => modalClose(modes.EMAIL_VALIDATE),
}))(EmailValidate);




// WEBPACK FOOTER //
// ./src/components/Popup/EmailValidate/index.js